// src/evidence/tiers.ts
var ConfidenceTier = {
  /** `>= high` — deterministic / strongly corroborated; safe to act on. */
  HIGH: "high",
  /** `>= medium` — semi-deterministic / strong heuristic; surface, allow review. */
  MEDIUM: "medium",
  /** `< medium` — probabilistic; show with the rationale, never auto-act. */
  LOW: "low"
};
var DEFAULT_TIER_CUTOFFS = { high: 0.9, medium: 0.6 };
function tierFor(score, cutoffs) {
  if (typeof score !== "number" || !Number.isFinite(score)) return ConfidenceTier.LOW;
  const high = cutoffs?.high ?? DEFAULT_TIER_CUTOFFS.high;
  const medium = cutoffs?.medium ?? DEFAULT_TIER_CUTOFFS.medium;
  if (score >= high) return ConfidenceTier.HIGH;
  if (score >= medium) return ConfidenceTier.MEDIUM;
  return ConfidenceTier.LOW;
}
var CONFIDENCE_TIER_LABELS = {
  [ConfidenceTier.HIGH]: "High confidence",
  [ConfidenceTier.MEDIUM]: "Medium confidence",
  [ConfidenceTier.LOW]: "Low confidence"
};
function formatConfidence(score) {
  if (typeof score !== "number" || !Number.isFinite(score)) return "";
  return `${Math.round(clampConfidence(score) * 100)}%`;
}
function clampConfidence(score) {
  return Math.max(0, Math.min(1, score));
}
function coerceConfidence(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export { CONFIDENCE_TIER_LABELS, ConfidenceTier, DEFAULT_TIER_CUTOFFS, clampConfidence, coerceConfidence, formatConfidence, tierFor };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map